import { PostBookingCardSkeleton, SkeletonLoader } from '@msc-b2c/shared-components';
import styles from './alreadypurchasedcontainerskeleton.module.scss';

export function AlreadyPurchasedContainerSkeleton() {
  const CategorySkeleton = () => (
    <div className={styles['already-purchased-container-skeleton__category']}>
      <SkeletonLoader
        styleOption={styles['already-purchased-container-skeleton__title']}
        height="32px"
        width="200px"
      />
      <div className={styles['already-purchased-container-skeleton__items']}>
        <PostBookingCardSkeleton />
        <PostBookingCardSkeleton />
      </div>
      <div className={styles['already-purchased-container-skeleton__button']}>
        <SkeletonLoader
          height="48px"
          width="201px"
        />
      </div>
    </div>
  );

  return (
    <div className={styles['already-purchased-container-skeleton']}>
      <CategorySkeleton />
      <CategorySkeleton />
      <CategorySkeleton />
    </div>
  );
}
